// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  label: {
    amigo: 'Chiedi ad Amigo',
    assistant: 'Assistente',
  },
  // The button's name while it shows a count of answers the person hasn't seen (the count itself is hidden from
  // screen readers).
  label_unread: {
    amigo_one: 'Chiedi ad Amigo, novità: {{count}}',
    amigo_other: 'Chiedi ad Amigo, novità: {{count}}',
    assistant_one: 'Assistente, novità: {{count}}',
    assistant_other: 'Assistente, novità: {{count}}',
  },
  unavailable_label: {
    amigo: 'Amigo non disponibile',
    assistant: 'Assistente non disponibile',
  },
  unavailable_text: {
    amigo: 'Amigo non è disponibile al momento.',
    assistant: "L'assistente non è disponibile al momento.",
  },
};
